var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPoliceCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.183,
    height: 96.937,
    viewBox: "0 0 71.183 96.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-92.441 -151.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "not_Found",
    "data-name": "not Found",
    transform: "translate(-3.861 -7.436)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_411",
    "data-name": "Elipse 411",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(134.486 222.436)",
    fill: "#3bcce1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_118",
    "data-name": "L\\xEDnea 118",
    y2: 15.226,
    transform: "translate(145.776 234.107) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_119",
    "data-name": "L\\xEDnea 119",
    y2: 15.226,
    transform: "translate(156.542 234.107) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "police_ico",
    transform: "translate(92.691 151.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1195",
    "data-name": "Trazado 1195",
    d: "M43.524,45.679a18.505,18.505,0,0,0,9.006-15.9V27.009a5.082,5.082,0,0,0,2.393-4.3V21.83l2.521-8.805a.924.924,0,0,0-.566-1.114c-.064-.009-5.17-1.936-14.77-11.637A.9.9,0,0,0,41.46,0H26.352A.913.913,0,0,0,25.7.274c-1.662,1.681-3.17,3.106-4.558,4.348l-1.571,1.37c-5.627,4.786-8.586,5.91-8.623,5.928a.92.92,0,0,0-.575,1.114L12.9,21.84v.877a5.08,5.08,0,0,0,2.676,4.476l-.064,2.594A18.471,18.471,0,0,0,20.378,42.3v.009l1.681,1.608a18.371,18.371,0,0,0,2.265,1.644l1.827.977a18.344,18.344,0,0,0,2.137.868,22.229,22.229,0,0,0,5.745.74,20.472,20.472,0,0,0,5.782-.758,18.977,18.977,0,0,0,1.891-.758ZM1.845,85.86c.055-1.589.228-19.51.53-20.844.649-2.9,2.548-7.956,8.038-9.143L18.35,53.69,28.407,66.313a.924.924,0,0,0,.7.347h.009a.887.887,0,0,0,.7-.338l4.193-5.115,4.193,5.115a.915.915,0,0,0,.7.338h.009a.883.883,0,0,0,.7-.347L49.689,53.681l7.983,2.2c5.435,1.178,7.335,6.229,7.992,9.134.3,1.334.475,19.255.53,20.844l.932,1.827a.943.943,0,0,0,.649-.265.9.9,0,0,0,.265-.649c-.009-2.073-.21-20.433-.594-22.15-.749-3.334-2.959-9.134-9.335-10.5l-8.495-2.338L43.524,49.9l-1.315-.037-.512.6-7.682,7.992-7.874-8.193-.7-.4-1.123.1-5.9,1.818L9.965,54.11C3.544,55.489,1.334,61.29.594,64.614.21,66.332.009,84.7,0,86.774a.9.9,0,0,0,.265.649.943.943,0,0,0,.649.265Zm41.231-34.2,4.731,1.461-8.9,11.162L35.239,59.81ZM42.254,44.3l-.009.009a16.73,16.73,0,0,1-3,1.343,20.712,20.712,0,0,1-10.449,0A16.671,16.671,0,0,1,17.336,29.8l.046-1.927A50.142,50.142,0,0,0,33.906,30.49h.548A49.815,49.815,0,0,0,50.7,27.768v2A16.677,16.677,0,0,1,42.254,44.3ZM53.087,22.707A3.241,3.241,0,0,1,51,25.749a48.276,48.276,0,0,1-17.081,2.923H33.9a48.072,48.072,0,0,1-17.081-2.923,3.232,3.232,0,0,1-2.092-3.042v-.393c1.882-.758,8.75-3.188,19.209-3.033,10.413-.146,17.282,2.274,19.154,3.033v.393ZM26.735,1.827h14.35C48.812,9.591,53.663,12.413,55.462,13.29l-2.055,7.179c-2.43-.941-9.235-3.151-19.474-3.014-10.258-.137-17.09,2.073-19.529,3.014L12.349,13.29C14.158,12.413,19.008,9.591,26.735,1.827ZM24.963,51.662,32.8,59.819l-3.672,4.476-8.9-11.171Z",
    fill: "#3bcce1",
    stroke: "#3bcce1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1196",
    "data-name": "Trazado 1196",
    d: "M17.606,61.8,9.814,63.725a.913.913,0,1,0,.438,1.772l7.791-1.927a.909.909,0,0,0,.667-1.105A.92.92,0,0,0,17.606,61.8Z",
    transform: "translate(-0.79 -5.349)",
    fill: "#3bcce1",
    stroke: "#3bcce1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1197",
    "data-name": "Trazado 1197",
    d: "M55.044,63.579l7.791,1.927a.913.913,0,1,0,.438-1.772l-7.791-1.927a.909.909,0,0,0-1.105.667A.924.924,0,0,0,55.044,63.579Z",
    transform: "translate(-4.707 -5.35)",
    fill: "#3bcce1",
    stroke: "#3bcce1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1198",
    "data-name": "Trazado 1198",
    d: "M32.5,9.108a4.536,4.536,0,0,0,2.055,5.764l1.589.859a.932.932,0,0,0,.877,0l1.589-.859A4.54,4.54,0,0,0,40.643,9.08c-.155-.365.155-1.041.32-1.288a.931.931,0,0,0-.192-1.224L39.958,5.9a.922.922,0,0,0-.913-.146A1.494,1.494,0,0,1,37.273,5.5a.943.943,0,0,0-1.425.009,1.492,1.492,0,0,1-1.763.247.918.918,0,0,0-.913.146l-.8.667a.909.909,0,0,0-.183,1.215A1.787,1.787,0,0,1,32.5,9.108Zm1.69.676a2.882,2.882,0,0,0-.027-2.11,3.224,3.224,0,0,0,2.411-.42,3.183,3.183,0,0,0,2.411.42,2.909,2.909,0,0,0-.018,2.137,2.751,2.751,0,0,1-1.242,3.444l-1.151.63-1.151-.621A2.772,2.772,0,0,1,34.186,9.783Z",
    transform: "translate(-2.774 -0.448)",
    fill: "#e72369",
    stroke: "#e72369",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPoliceCross);
export default __webpack_public_path__ + "static/media/user-police-cross.171c2d3128f1a74ba79e1ad25b1b3858.svg";
export { ForwardRef as ReactComponent };